export default {
  namespaced: true,
  axis_body_cam: {
    title: 'Axis Body Cam',
    overview: {
      title: 'General',
      devices: 'Cámaras',
      users: 'Usuarios',
      recordings: 'Grabaciones',
      total: 'Total',
      active: 'Activos',
      today: 'Hoy',
      transferring: 'Transfiriendo',
      complete: 'Completas',
      storage_used: 'Almacenamiento usado',
      recent_recordings: 'Grabaciones recientes',
      configure_dock: 'Configuración Body Worn Collector',
      configure_dock_hint: 'Descarga el archivo de conexión para dar de alta un dock en Body Worn Manager',
    },
    devices: {
      title: 'Cámaras',
      serial_number: 'Serie',
      model: 'Modelo',
      name: 'Nombre',
      active: 'Activo',
      assigned_user: 'Usuario asignado',
      system_controller: 'Dock',
      recordings_count: 'Grabaciones',
      last_synced_at: 'Última sincronización',
      device_tag: 'Tag',
      reseller: 'Reseller',
      proxy_rtsp_server: 'Stream (heredado del dock)',
      no_locations_for_day: 'Sin ubicaciones registradas ese día',
    },
    system_controllers: {
      title: 'Docks',
      serial_number: 'Serie',
      model: 'Modelo',
      name: 'Nombre',
      units: 'Instalaciones',
      devices_count: 'Cámaras',
      last_synced_at: 'Última sincronización',
      proxy_rtsp_server: 'Stream',
      users: 'Usuarios con acceso',
      groups: 'Grupos con acceso',
    },
    users: {
      title: 'Usuarios',
      name: 'Nombre',
      active: 'Activo',
      devices_count: 'Cámaras',
      recordings_count: 'Grabaciones',
      last_synced_at: 'Última sincronización',
    },
    recordings: {
      title: 'Grabaciones',
      container_name: 'Sesión',
      user: 'Usuario',
      device: 'Cámara',
      start_time: 'Inicio',
      stop_time: 'Fin',
      status: 'Estado',
      files: 'Archivos',
      download: 'Descargar',
      no_files: 'Sin archivos',
      play: 'Reproducir',
      download_all: 'Descargar todo',
      download_started: 'Descarga iniciada',
      links_error: 'No se pudieron obtener los enlaces de la grabación',
      part: 'Parte',
      playing: 'Reproduciendo',
      unsupported_format: 'Este navegador no reproduce el formato MKV, usa Chrome/Edge o descarga el archivo',
      part_error: 'No se pudo reproducir esta parte',
      no_videos: 'Esta grabación no tiene video',
    },
  },
}
